import Cookie from "js-cookie";

import {
  CLOUD_API_DEPLOYED,
  getCookieDomain,
} from "@skydio/api_util/src/backends/cloud_api/requests-browser";

const FRONTEND_BETA_COOKIE = "frontend_beta";

export function getFrontendBetaCookie(): boolean | null {
  const value = Cookie.get(FRONTEND_BETA_COOKIE);
  if (value === "true") return true;
  if (value === "false") return false;
  return null;
}

export function setFrontendBetaCookie(isBeta: boolean): void {
  Cookie.set(FRONTEND_BETA_COOKIE, isBeta ? "true" : "false", {
    domain: CLOUD_API_DEPLOYED ? getCookieDomain() : undefined,
    path: "/",
    secure: CLOUD_API_DEPLOYED,
    sameSite: "lax",
    expires: 365,
  });
}

export function removeFrontendBetaCookie(): void {
  Cookie.remove(FRONTEND_BETA_COOKIE, {
    domain: CLOUD_API_DEPLOYED ? getCookieDomain() : undefined,
    path: "/",
  });
}
